import image1 from "./images/ensecure-2023_01.jpg";
import image2 from "./images/ensecure-2023_02.jpg";

const Index = () => {
  return (
    <div>
      <table
        id="Table_01"
        width="750"
        border="0"
        cellPadding="0"
        cellSpacing="0"
        align="center"
      >
        <thead />
        <tbody>
          <tr>
            <td align="right" valign="middle" style={{ padding: "5px" }}>
              <p>
                본 메일이 보이지 않는 경우
                <a
                  href="https://www.scgs.co.kr/edm/ensecure/index.html"
                  target="_blank"
                  style={{ textDecoration: "none", color: "#5694d9" }}
                >
                  이곳
                </a>
                을 눌러 주십시오.
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <img
                src={image1}
                alt="img"
                width={750}
                useMap="#Map"
                border="0"
              />
            </td>
          </tr>
          <tr>
            <td>
              <img src={image2} alt="" width={750} useMap="#Map2" border="0" />
            </td>
          </tr>
        </tbody>
        <tfoot />
      </table>
      <map name="Map">
        <area
          shape="rect"
          coords="47,1758,356,1823"
          href="https://docs.google.com/forms/d/e/1FAIpQLSdDtuU32WwY6B1Ve3t2caVJwb1-_aIlx6DOkVQK-7jm4MRR6Q/viewform"
          target="_blank"
        />
        <area
          shape="rect"
          coords="393,1757,700,1821"
          href="https://docs.google.com/forms/d/e/1FAIpQLSedHMD5TBvS4zNp7lTsKn-_3npxQqPczeWPjs-wCNjGqz8i0w/viewform"
          target="_blank"
        />
      </map>

      <map name="Map2">
        <area
          shape="rect"
          coords="3,1449,314,1538"
          href="https://www.scgs.co.kr/"
          target="_blank"
        />
      </map>
    </div>
  );
};
export default Index;
